import React, { useEffect, useState, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { MailCheck, XCircle, Loader2 } from 'lucide-react';
import { authAPI } from '../../services/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard against double-run in StrictMode
    ran.current = true;

    if (!token) {
      setStatus('error');
      setMessage('This verification link is invalid or incomplete.');
      return;
    }
    (async () => {
      const result = await authAPI.verifyEmail(token);
      if (result.success) {
        setStatus('success');
        setMessage(result.message || 'Your email has been verified.');
      } else {
        setStatus('error');
        setMessage(result.message || 'Verification failed. The link may have expired.');
      }
    })();
  }, [token]);

  return (
    <div className="max-w-md mx-auto py-16 text-center">
      {status === 'verifying' && (
        <>
          <Loader2 className="mx-auto h-12 w-12 text-brand-500 animate-spin" />
          <h1 className="mt-6 text-2xl font-bold tracking-tight text-ink-900">Verifying your email…</h1>
        </>
      )}
      {status === 'success' && (
        <>
          <div className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-400 to-teal-500 text-white shadow-soft">
            <MailCheck className="h-7 w-7" />
          </div>
          <h1 className="mt-6 text-2xl font-bold tracking-tight text-ink-900">Email verified</h1>
          <p className="mt-2 text-sm text-ink-500">{message}</p>
          <Link to="/" className="mt-6 inline-flex items-center justify-center rounded-lg bg-ink-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-ink-800 transition">
            Go to dashboard
          </Link>
        </>
      )}
      {status === 'error' && (
        <>
          <div className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-red-100 text-red-600">
            <XCircle className="h-7 w-7" />
          </div>
          <h1 className="mt-6 text-2xl font-bold tracking-tight text-ink-900">Verification failed</h1>
          <p className="mt-2 text-sm text-ink-500">{message}</p>
          <Link to="/profile" className="mt-6 inline-flex items-center justify-center rounded-lg border border-ink-200 px-5 py-2.5 text-sm font-semibold text-ink-700 hover:bg-ink-100 transition">
            Resend from your profile
          </Link>
        </>
      )}
    </div>
  );
};

export default VerifyEmail;
